module.exports = "https://img.xiyuyouxi.com/saas/img/mark_dele.efe5fa07.png";